export class Courier {
  countryId?: number;
  formatCountry?: string;
  courierType?: string;
  id?: number;
  name?: string;
  code?: string;
  description?: string;
  active?: boolean;
  formatActive?: string;
  createdBy?: string;
  createdDate?: Date;
  lastModifiedBy?: string;
  lastModifiedDate?: Date;
}
